// PaymentRedirect.js
import React, { useEffect, useState } from "react";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import { call } from "services/axiosService/core";
import getStripe from "./getStripe";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Loader from "pages/loader/Loader";
import { useTranslation } from "react-i18next";
import InnerPaymentRedirect from "./InnerPaymentRedirect"; // <- move your logic here
import * as Sentry from "@sentry/browser";
import { useMaterialUIController, setProfile } from "context";

export default function PaymentRedirect() {
  const { t } = useTranslation();
  const [stripePromise, setStripePromise] = useState(null);
  const [controller, dispatch] = useMaterialUIController();
  const { profile, persona } = controller;

  useEffect(() => {
    call(`payments/config/${profile.id}`, "GET", {})
      .then((response) => {
        if (response.status === 200 && response.data.publish_key) {
          setStripePromise(getStripe(response.data.publish_key));
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
      });
  }, []);

  return (
    <div>
      {stripePromise ? (
        <Elements stripe={stripePromise}>
          <InnerPaymentRedirect /> {/* all your useStripe logic goes here */}
        </Elements>
      ) : (
        <DashboardLayout>
          <DashboardNavbar title="Payment-Redirect" />
          <Dialog open={stripePromise == null}>
            <DialogContent
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "300px",
                overflow: "hidden",
                padding: 4,
              }}
            >
              <Loader loaderText={t("loaderText.processingPayment")} />
            </DialogContent>
          </Dialog>
        </DashboardLayout>
      )}
    </div>
  );
}
